// extracted by mini-css-extract-plugin
module.exports = {"root":"tooltip_root__3VcRO"};